module.exports = __webpack_public_path__ + "static/nab-bg-8acbb12a6d7e48037f4de0fde1a359b6.png";